import { createFileRoute } from '@tanstack/react-router';
import { AssessmentInitialPage } from '@/pages/assessment/ui/AssessmentInitialPage';

export const Route = createFileRoute('/_protected/assessment/')({
  component: AssessmentInitialPage,
});
